const SvgPlace1 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M16 2.667A9.326 9.326 0 0 0 6.667 12C6.667 19 16 29.333 16 29.333S25.333 19 25.333 12A9.326 9.326 0 0 0 16 2.667m0 12.666a3.334 3.334 0 0 1 0-6.666 3.334 3.334 0 0 1 0 6.666" />
  </svg>;
export default SvgPlace1;